module.exports = __webpack_public_path__ + "static/media/shanghai-10-highlight.e2b7fbc3.png";